import { ConfigActionType } from '../action-types/configTypes';
import { ConfigActions } from '../actions/configTypes';
import { Dispatch } from 'redux';

export const setConfigFile = (configFile: ConfigFile) => {
  return (dispatch: Dispatch<ConfigActions>) => {
    dispatch({
      type: ConfigActionType.SET_CONFIG_FILE,
      payload: configFile,
    });
  };
};
